import React from "react";
import API from '../Utils/api'
import GerenteTemplate from "./GerenteTemplate";
import Cleave from "cleave.js/react"
import * as $ from 'jquery';
import * as yup from 'yup';

const initialFormValues = {
    form: {
        nome: '',
        telefone: '',
        cpf: ''
    }
}

const schema = yup.object().shape({
    nome: yup.string().label('Nome').required('Nome é obrigatório.').trim(),
    telefone: yup.string().label('Telefone').required('Telefone é obrigatório.').trim(),
    cidade: yup.string().label('Cidade').required('Cidade obrigatória.').trim(),
    estado: yup.string().label('Estado').required('Estado obrigatório.').trim()
})


export class GerenteCriarPedidos extends React.Component {
    constructor(props) {
        window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
        super(props);
        this.state = {
            user: JSON.parse(localStorage.getItem("user")),
            serieId: localStorage.getItem("serie"),
            serie: null,
            clientes: [],
            filteredClienteList: [],
            listaClientesSelecionados: {},
            cloneCartelasArray: [],
            filteredCode: "",
            cartelaCode: "",
            form: {
                nome: '',
                telefone: '',
                cidade: '',
                estado: ''
            },
            cleaves: {
                telefone: null
            },
            errors: []
        }

        this.getSerie();
        this.serieSetBusy(this.state.serieId, true);
    }

    async getClientes(spell) {
        try {
            const response = await API.post("/api/usuarios/filtrar-clientes-por-tutor", {
                tutorId: this.state.serie.cambistaId._id,
                spell: spell
            })
            this.setState({
                filteredClienteList: [... response.data.sort(this.compararClientes)]
            })

        } catch (err) {
            console.log(err)
        }
    }

    async getSerie() {
        try {
            const response = await API.post("/api/series/serie", {serieId: this.state.serieId});
            this.setState({
                serie: response.data,
                cloneCartelasArray: [... response.data.cartelas]
            });
            this.serieSetBusy(this.state.serieId, true);
            this.getClientes("anto");
        } catch (err) {
            console.log(err);
        }
    };


    async serieSetBusy(_id, isBusy) {
        try {
            const response = await API.put("/api/series/set-busy", {_id, isBusy})
        } catch (err) {
            console.log(err)
        }
    }

    compararClientes(a, b) {
        if (a.nome > b.nome) {
            return 1;
        }
        if (a.nome < b.nome) {
            return -1;
        }

        return 0
    }

    selecionarCliente(e) {
        const clienteObj = JSON.parse(e.target.value)
        if (Object.entries(clienteObj)[0][1] != null) {

            this.setState({
                listaClientesSelecionados: {
                    ...this.state.listaClientesSelecionados,
                    ... clienteObj
                }
            })
        } else {
            delete this.state.listaClientesSelecionados[Object.entries(clienteObj)[0][0]]
            this.setState({listaClientesSelecionados: this.state.listaClientesSelecionados})
        }

    }


    async criarPedido(e) {
        var cartela = [this.state.listaClientesSelecionados[e.target.name].cartela];
        var clienteId = this.state.listaClientesSelecionados[e.target.name].clienteId;
        this.state.cloneCartelasArray.map((card, index) => {
            if (card.codigo == this.state.listaClientesSelecionados[e.target.name].cartela.codigo) {
                this.state.cloneCartelasArray.splice(index, 1);
            }
        })
        try {
            const response = await API.post("/api/pedidos/criar-pedido-otimizado", {
                clienteId: clienteId,
                cambistaId: this.state.serie.cambistaId._id,
                gerenteId: this.state.user._id,
                serieId: this.state.serie._id,
                cartela: cartela,
                taxaComissaoCambista: this.state.serie.cambistaId.comissao
            })

            alert("Pedido criado com sucesso!")
            document.getElementById("select" + e.target.name).disabled = true;
            document.getElementById("button" + e.target.name).disabled = true;
            document.getElementById("input-avulso").value = "";
            this.setState({cloneCartelasArray: this.state.cloneCartelasArray, filteredCode: ""});

        } catch (err) {
            console.log(err)
        }
    }


    filtrarCartela(e) {
        this.setState({filteredCode: e.target.value, cartelaCode: e.target.value})
    }

    telefoneInit = (cleave) => {
        this.setState(state => {
            return {
                ...state,
                cleaves: {
                    ...state.cleaves,
                    telefone: cleave
                }
            }
        })
    }

    handleRequiredCleaveLength = event => {
        const minLength = event.target.dataset.length
        const {name, rawValue} = event.target

        if (rawValue && rawValue.length < minLength) {
            this.setState(state => {
                return {
                    ...state,
                    form: {
                        ...state.form,
                        [name]: ''
                    }
                }
            })
            this.state.cleaves[name].setRawValue('')
        }
    }

    handleChangeCadastroRapido(event) {
        const {name, value} = event.target
        if (name) {
            if (this.state.form[name] == undefined) {
                this.state.form = {
                    ...this.state.form,
                    [name]: value
                }
            }
            this.state.form[name] = value;
            this.setState({form: this.state.form})
        }
    }

    resetForm = () => {

        this.setState({
            form: {
                ... initialFormValues
            }
        })
        for (let key in this.state.cleaves) {
            this.state.cleaves[key] = null;
        }
    }

    hasFormError = (label = '') => {
        const errors = this.state.errors

        if (errors.length > 0) {
            const hasError = errors.filter(item => item.path === label)
            return hasError.length > 0
        }

        return false
    }

    getFormError = (label = '') => {
        const errors = this.state.errors

        if (errors.length > 0) {
            const hasError = errors.filter(item => item.path === label)
            return hasError
        }

        return []
    }

    cadastrarCliente = async (e) => {
        try {
            await schema.validate(this.state.form, {abortEarly: false})

            const dados = {
                ...this.state.form,
                tutorId: this.state.serie.cambistaId._id
            }
            const response = await API.post('/api/usuarios/fast', dados)

            const {error} = response.data
            if (error) 
                throw new Error(error)
            const update = this.state.filteredClienteList;
            update.unshift(response.data)
            this.setState(state => {
                return {
                    ...state,
                    filteredClienteList: update
                }
            })
            $('#modalCadastroRapido').modal('hide')

            setTimeout(() => {
                alert('Usuário cadastrado com sucesso.');
                this.setState({cartelaCode: ''});
                document.getElementById("input-avulso").value = "";
                document.getElementById("input-cliente").value = "";

            }, 1000)

            this.resetForm()
        } catch (error) {
            if (error.name === 'ValidationError') {
                this.setState(state => {
                    return {
                        ...state,
                        errors: error.inner
                    }
                })
            } else {
                alert(error.message)
            }
        }
    }

    filtrarCliente(e) {
        this.getClientes(e.target.value)
    }

    handlerButton(e) {
        document.getElementById("select" + e.target.name).disabled = true;
        document.getElementById("button" + e.target.name).disabled = true;
        document.getElementById("input-avulso").value = "";
        document.getElementById("input-cliente").value = "";

        this.criarPedido(e);
        this.setState({cartelaCode: ''})
    }

    render() {

        return (
            <GerenteTemplate label="Criar Pedidos">
                <div className="modal fade" id="modalCadastroRapido" tabIndex="-1" role="dialog" aria-labelledby="modalCadastroRapidoTitle" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header pb-3">
                                <h5 className="modal-title font-weight-bold" id="modalCadastroRapidoTitle">Cadastro
                                                                                                                                                                                                      rápido de clientes</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body"
                                style={
                                    {
                                        borderTop: '1px solid #e9ecef',
                                        borderBottom: '1px solid #e9ecef'
                                    }
                            }>
                                <form>
                                    <div className="form-row">
                                        <div className="form-group col">
                                            <input type="text" name="nome"
                                                className={
                                                    `form-control ${
                                                        this.hasFormError('nome') && 'is-invalid'
                                                    }`
                                                }
                                                id="nome"
                                                placeholder="Nome completo"
                                                value={
                                                    this.state.form.nome || ''
                                                }
                                                onChange={
                                                    this.handleChangeCadastroRapido.bind(this)
                                                }/>
                                            <div className="invalid-feedback">
                                                {
                                                this.getFormError('nome').map(item => item.message)
                                            } </div>
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group col-lg-6">
                                            <Cleave name="telefone" type="tel" placeholder="Telefone" data-length="10"
                                                onInit={
                                                    this.telefoneInit
                                                }
                                                className={
                                                    `form-control ${
                                                        this.hasFormError('telefone') && 'is-invalid'
                                                    }`
                                                }
                                                options={
                                                    {
                                                        phone: true,
                                                        phoneRegionCode: 'BR'
                                                    }
                                                }
                                                value={
                                                    this.state.form.telefone || ''
                                                }
                                                onChange={
                                                    this.handleChangeCadastroRapido.bind(this)
                                                }
                                                onBlur={
                                                    this.handleRequiredCleaveLength
                                                }/>
                                            <div className="invalid-feedback">
                                                {
                                                this.getFormError('telefone').map(item => item.message)
                                            } </div>
                                        </div>
                                        <div className="form-row">
                                            <div className="form-group col">
                                                <input type="text" name="cidade"
                                                    className={
                                                        `form-control ${
                                                            this.hasFormError('cidade') && 'is-invalid'
                                                        }`
                                                    }
                                                    id="cidade"
                                                    placeholder="Cidade"
                                                    value={
                                                        this.state.form.cidade || ''
                                                    }
                                                    onChange={
                                                        this.handleChangeCadastroRapido.bind(this)
                                                    }/>
                                                <div className="invalid-feedback">
                                                    {
                                                    this.getFormError('cidade').map(item => item.message)
                                                } </div>
                                            </div>
                                        </div>
                                        <div className="form-row pl-4">
                                            <div className="form-group col">
                                                <input type="text" name="estado"
                                                    className={
                                                        `form-control ${
                                                            this.hasFormError('estado') && 'is-invalid'
                                                        }`
                                                    }
                                                    id="estado"
                                                    placeholder="Estado"
                                                    value={
                                                        this.state.form.estado || ''
                                                    }
                                                    onChange={
                                                        this.handleChangeCadastroRapido.bind(this)
                                                    }/>
                                                <div className="invalid-feedback">
                                                    {
                                                    this.getFormError('estado').map(item => item.message)
                                                } </div>
                                            </div>
                                        </div>

                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer d-flex justify-content-end pt-3">
                                <button type="button" className="btn btn-fill btn-secondary mr-1" data-dismiss="modal">Cancelar
                                </button>
                                <button type="button"
                                    onClick={
                                        this.cadastrarCliente.bind(this)
                                    }
                                    className="btn btn-fill btn-success">Salvar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container">
                    <div className="d-flex">
                        <button type="button"
                            title={'Cadastro rápido'}
                            className="btn btn-primary btn-fill btn-icon float-md-right ml-3 mr-md-1"
                            data-toggle="modal"
                            onClick={
                                this.resetForm
                            }
                            data-target="#modalCadastroRapido">
                            <i className="fas fa-rocket"></i>
                            Cadastrar cliente
                        </button>
                    </div>
                    <div className="mt-3 d-flex justify-content-center">

                        <Cleave id="input-avulso" data-length="7"
                            className={`ml-1 form-control`}
                            options={
                                {
                                    numericOnly: true,
                                    delimiters: ['-'],
                                    blocks: [5, 1]
                                }
                            }

                            style={
                                {
                                    maxWidth: "30%",
                                    minWidth: "30%"
                                }
                            }
                            value={
                                this.state.cartelaCode || ""
                            }
                            onChange={
                                this.filtrarCartela.bind(this)
                            }
                            placeholder="código 00000-0"/>
                        <input id="input-cliente" className="ml-1 form-control"
                            onBlur={
                                this.filtrarCliente.bind(this)
                            }
                            placeholder="nome de cliente"></input>
                    </div>
                    <div class="row">

                        <table class="table">
                            <thead>
                                <tr>
                                    <th scope="col">No.</th>
                                    <th scope="col">Vendedor</th>
                                    <th scope="col">Cartela</th>
                                    <th scope="col">Cliente</th>
                                    <th scope="col">Criar pedido</th>
                                </tr>
                            </thead>
                            <tbody> {
                                this.state.serie ?. cartelas.map((cartela, index) => {
                                    return (
                                        <tr className={
                                            cartela.codigo.includes(this.state.filteredCode) ? "" : "d-none"
                                        }>
                                            <td>{
                                                index + 1
                                            }</td>
                                            <td>{
                                                this.state.serie.cambistaId.nome
                                            }</td>
                                            <td>{
                                                cartela.codigo
                                            }</td>
                                            <td>
                                                <select id={
                                                        "select" + index
                                                    }
                                                    onChange={
                                                        this.selecionarCliente.bind(this)
                                                    }
                                                    className="custom-select">
                                                    <option value={
                                                            JSON.stringify({[index]: null})
                                                        }
                                                        selected>
                                                        {
                                                        this.state.listaClientesSelecionados[index] ? this.state.listaClientesSelecionados[index] ?. nome : "Selecionar..."
                                                    }</option>
                                                    {/* <option value={
                                                        JSON.stringify({
                                                            [index]: {
                                                                clienteId: "5efa084f848650c6b2f01387",
                                                                cartela: cartela
                                                            }
                                                        })
                                                    }>Cliente Avulso</option> */}
                                                    {
                                                    !this.state.listaClientesSelecionados[index] ? this.state.filteredClienteList ?. map(cliente => {
                                                        return <option value={
                                                            JSON.stringify({
                                                                [index]: {
                                                                    clienteId: cliente._id,
                                                                    cartela: cartela,
                                                                    nome: cliente.nome + " - " + cliente.telefone
                                                                }
                                                            })
                                                        }>
                                                            {
                                                            cliente.nome
                                                        }
                                                            - {
                                                            cliente.telefone
                                                        }</option>
                                                }) : ""
                                                } </select>
                                            </td>

                                            <td>
                                                <button id={
                                                        "button" + index
                                                    }
                                                    disabled={
                                                        this.state.listaClientesSelecionados[index] ? false : true
                                                    }
                                                    name={index}
                                                    onClick={
                                                        this.handlerButton.bind(this)
                                                    }
                                                    className="btn-fill btn btn-warning">Criar pedido</button>
                                            </td>

                                        </tr>
                                    )
                                })
                            } </tbody>
                        </table>
                    </div>
                </div>
            </GerenteTemplate>
        );
    }
}

export default GerenteCriarPedidos;
